export const authConstants = {
    LOCAL_TENANT_KEY: 'VelappityTenantId',
    SET_TENANT_QUERY: 'SET_TENANT_QUERY',
    SET_PERMISSIONS: "SET_PERMISSIONS",
    SET_FEATURES: "SET_FEATURES",
    CLEAR_FEATURES_AND_PERMISSIONS: "CLEAR_FEATURES_AND_PERMISSIONS",
    SET_USER_DETAILS: "SET_USER_DETAILS",
    CLEAR_USER_DETAILS: "CLEAR_USER_DETAILS"
};